<template>
  <div class="field form_field">
    <form-field-select
      :label="label"
      :value="defaultValue"
      :validation-errors="validationErrors"
      :size="size"
      :disabled="!hasUsers"
      @change="handleInput"
    >
      <option :value="null">Choose User</option>
      <option
        v-for="(user, index) in users"
        :key="index"
        :value="user.id"
      >
        {{ user.full_name }} <{{ user.outgoing_email_address }}>
      </option>
    </form-field-select>

    <template v-if="!hasUsers">
      <p class="help">No email integration. Setup email integration inside <router-link :to="{name: 'settings', params: {tab: 'email'}}">Email Settings</router-link>.</p>
    </template>
  </div>
</template>

<script>
import {ENUMS} from "../../services/enums";

export default {
  name: "FormFieldSelectUserEmails",
  props: {
    value: {},
    label: {
      type: String,
      default: 'From'
    },
    validationErrors: {
      type: [String, Array, undefined]
    },
    size: {
      type: String,
      default: 'is-small'
    }
  },
  created() {
    this.handleInput(this.defaultValue);
  },
  computed: {
    defaultValue() {
      if (!this.hasUsers) {
        return null;
      }

      return this.value;
    },
    users() {
      const integrationType = this.$store.getters.market.email_integration_type

      if (integrationType === ENUMS.EmailIntegrationTypeEnum.Gmail.value) {
        return this.$store.getters.gmailActiveUsers
      }

      if (integrationType === ENUMS.EmailIntegrationTypeEnum.MailGun.value) {
        return this.$store.getters.mailgunActiveUsers
      }

      return []
    },
    hasUsers() {
      return this.users.length !== 0;
    },
  },
  methods: {
    handleInput(val) {
      this.$emit('input', val);
      this.$emit('change', val);
      this.$emit('selected', val);
    },
  }
}
</script>

<style lang="scss" scoped>
@import "../../styles/variables/variables";

.help {
  margin-top: -0.50rem;
  margin-bottom: 0.75rem;
}
</style>
